/**
 * Handles the transition for a given action.
 * If `document.startViewTransition` is available, it uses that for the transition.
 * Otherwise, it directly calls the action.
 *
 * @param {Function} action - The action to be performed during the transition.
 */
export function handleTransition(action) {
    if (document.startViewTransition) {
        document.startViewTransition(action);
    } else {
        action();
    }
}
